/* eslint-disable node/prefer-global/process */
import { useBodyStore } from '@autobid/nuxt-pinia-store/store/useBodyStore'
import { computed } from 'vue'
import { useDebounce } from './useDebounce'

export function useIsMobile() {
  const { resolution } = storeToRefs(useBodyStore())
  const cookie = useCookie('isMobile', { maxAge: 60 * 60 * 24 * 7 })
  const isMobile = computed(() => {
    if (typeof window === 'undefined') {
      const value = Number(cookie.value)

      if (Number.isNaN(value)) {
        return false
      }

      return Boolean(value)
    }

    return resolution.value.width < 768
  })

  const updateCookie = useDebounce(() => {
    if (typeof window === 'undefined') {
      return
    }
    cookie.value = window.innerWidth < 768 ? '1' : '0'
  })

  if (process.client) {
    watch(isMobile, () => {
      updateCookie()
    })
  }

  return isMobile
}
